import { fetchUtils } from 'admin-on-rest';
import {
  GET_LIST,
  GET_ONE,
  GET_MANY,
  GET_MANY_REFERENCE,
  CREATE,
  UPDATE,
  DELETE
} from 'admin-on-rest';
import { API_URL } from './constants';
import { getToken } from './authClient';

const { fetchJson, queryParameters } = fetchUtils;

const addCapabilities = requestHandler => (type, resource, params) => {
  return requestHandler(type, resource, params)
    .then(result => {
      return result;
    })
    .catch(e => {
      if (e.message === 'jwt expired' || e.message === 'jwt malformed') {
        setTimeout(() => (window.location.href = '#/login'), 1000);
        throw new Error('Authentication expired. Please login again');
      }
      throw e;
    });
};

const fetcher = addCapabilities(fetchJson);
// const fetcher = fetchJson;

/**
 * Maps admin-on-rest queries to a simple REST API
 *
 * The REST dialect is similar to the one of FakeRest
 * @see https://github.com/marmelab/FakeRest
 * @example
 * GET_LIST     => GET http://my.api.url/posts?sort=['title','ASC']&range=[0, 24]
 * GET_ONE      => GET http://my.api.url/posts/123
 * GET_MANY     => GET http://my.api.url/posts?filter={ids:[123,456,789]}
 * UPDATE       => PUT http://my.api.url/posts/123
 * CREATE       => POST http://my.api.url/posts/123
 * DELETE       => DELETE http://my.api.url/posts/123
 */
const restClient = (apiUrl, httpClient = fetcher) => {
  /**
   * @param {String} type One of the constants appearing at the top if this file, e.g. 'UPDATE'
   * @param {String} resource Name of the resource to fetch, e.g. 'posts'
   * @param {Object} params The REST request params, depending on the type
   * @returns {Object} { url, options } The HTTP request parameters
   */
  const convertRESTRequestToHTTP = (type, resource, params) => {
    let url = '';
    const options = {
      user: { authenticated: true, token: getToken() }
    };
    console.log('convertRESTRequestToHTTP', type, resource, params);
    switch (type) {
      case GET_LIST: {
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;
        const where = {};
        if (Object.keys(params.filter).length > 0) {
          let filter = Object.keys(params.filter).reduce((acc, key) => {
            if (key.indexOf('q_or_') === 0) {
              acc['or'] = params.filter[key]['or'];
              // } else if (key === 'fieldName') {
              // } else if (key === 'fieldValue') {
            } else if (key === 'updatedAtAfter' || key === 'updatedAtBefore') {
              if (!acc.updatedAt) {
                acc.updatedAt = {};
              }
              if (key === 'updatedAtAfter') {
                acc.updatedAt['>'] = params.filter[key];
              } else {
                acc.updatedAt['<'] = params.filter[key];
              }
            } else {
              acc[key] = params.filter[key];
            }
            return acc;
          }, {});
          where.where = JSON.stringify(filter);
        }

        const query = {
          sort: `${field} ${order}`,
          limit: perPage,
          skip: (page - 1) * perPage,
          ...where
        };
        url = `${apiUrl}/${resource}?${queryParameters(query)}`;
        break;
      }
      case GET_ONE:
        url = `${apiUrl}/${resource}/${params.id}`;
        break;
      case GET_MANY: {
        const query = {
          where: JSON.stringify({ id: params.ids })
        };
        url = `${apiUrl}/${resource}?${queryParameters(query)}`;
        break;
      }
      case GET_MANY_REFERENCE: {
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;
        const query = {
          sort: `${field} ${order}`,
          limit: perPage,
          skip: (page - 1) * perPage,
          filter: JSON.stringify({
            ...params.filter,
            [params.target]: params.id
          })
        };
        url = `${apiUrl}/${resource}?${queryParameters(query)}`;
        break;
      }
      case UPDATE:
        if (params.action) {
          url = `${apiUrl}/${resource}/${params.action}`;
        } else {
          url = `${apiUrl}/${resource}/${params.id}`;
        }
        options.method = 'PUT';
        options.body = JSON.stringify(params.data);
        break;
      case CREATE:
        url = `${apiUrl}/${resource}`;
        options.method = 'POST';
        options.body = JSON.stringify(params.data);
        break;
      case DELETE:
        url = `${apiUrl}/${resource}/${params.id}`;
        options.method = 'DELETE';
        break;
      default:
        throw new Error(`Unsupported fetch action type ${type}`);
    }
    return { url, options };
  };

  /**
   * @param {Object} response HTTP response from fetch()
   * @param {String} type One of the constants appearing at the top if this file, e.g. 'UPDATE'
   * @param {String} resource Name of the resource to fetch, e.g. 'posts'
   * @param {Object} params The REST request params, depending on the type
   * @returns {Object} REST response
   */
  const convertHTTPResponseToREST = (response, type, resource, params) => {
    const { headers, json } = response;
    console.log('convertHTTPResponseToREST', json, params);
    switch (type) {
      case GET_LIST:
      case GET_MANY_REFERENCE:
        return {
          data: json.data,
          total: parseInt(headers.get('x-total-count'), 10)
        };
      case CREATE:
        return { data: { ...json.data, id: json.data.id } };
      default:
        return { data: json.data };
    }
  };

  /**
   * @param {string} type Request type, e.g GET_LIST
   * @param {string} resource Resource name, e.g. "posts"
   * @param {Object} payload Request parameters. Depends on the request type
   * @returns {Promise} the Promise for a REST response
   */
  return (type, resource, params) => {
    const { url, options } = convertRESTRequestToHTTP(type, resource, params);
    return httpClient(url, options).then(response =>
      convertHTTPResponseToREST(response, type, resource, params)
    );
  };
};

/*
const httpClient = (url, options = {}, ...args) => {
  console.log("asdasd", url, options, args);
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/json" });
  }
  // add your own headers here
  options.headers.set("X-Custom-Header", "foobar");
  return fetchUtils.fetchJson(url, options);
};
const restClient = simpleRestClient(
  "http://127.0.0.1:5984/",
  httpClient
);
*/

export default restClient(API_URL);



// WEBPACK FOOTER //
// ./src/aor-sails.js